var debounce = require('debounce');

document.addEventListener("DOMContentLoaded", function(e) {
	window.addEventListener('resize', debounce(adjust_hero_height, 150));

	let images = [];
	let init = false;
	
	function adjust_hero_height() {
		let slider = document.getElementById('_dynamic_list-8-2160322');

		if(slider) {
			let slides = slider.getElementsByClassName('swiper-slide');

			if(slides.length > 0) {
				for(let i = 0; i < slides.length; i++) {
					let styles = slides[i].currentStyle || window.getComputedStyle(slides[i], false);
					let image_url = styles.backgroundImage.slice(4, -1).replace(/"/g, "");

					if(images[image_url]) {
						apply_slide_height(slides[i], (window.innerWidth * images[image_url].calc));
					} else {
						var img_tag = new Image();
						img_tag.onload = function() {

							images[image_url] = {
								width: this.width,
								height: this.height,
								calc: this.height / this.width,
							};

							apply_slide_height(slides[i], (window.innerWidth * images[image_url].calc));

							if(!init && slides[i].classList.contains('swiper-slide-active')) {
								slider.style.height = (window.innerWidth * images[image_url].calc) + 'px';
								init = true;
							}
						};
						img_tag.src = image_url;
					}

					
				}
			}
		}
	}

	function apply_slide_height(slide, height) {
		slide.style.height = height + 'px';
	}

	setTimeout(function() {
		setInterval(adjust_hero_height, 500);
	}, 300)
});